import { ILogger } from '@cian/logger';
import { IHttpApi } from '@cian/http-api';

import {
  fetchCianApiSiteV1GetUserDataByRequest,
  TCianApiSiteV1GetUserDataByRequestResponse,
} from '../../repositories/monolith-python/cian-api/site/v1/get-user-data-by-request';

export async function getUserData(cookie: string, logger: ILogger, httpApi: IHttpApi, subdomain: string) {
  try {
    const { response }: TCianApiSiteV1GetUserDataByRequestResponse = await fetchCianApiSiteV1GetUserDataByRequest({
      httpApi,
      config: { subdomain },
    });

    return response;
  } catch (error) {
    if (logger) {
      logger.error(error, {
        message: error.message,
        stack: error.stack,
        comment: 'Error in getUserData',
      });
    }
    throw error;
  }
}
